import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export function List({
  className,
  children,
  dense = false,
  as = "ul",
}: {
  className?: string;
  children: ReactNode;
  dense?: boolean;
  as?: "ul" | "ol";
}): JSX.Element {
  const Component = as;
  const spacingClass = dense ? "space-y-1" : "space-y-2";
  return (
    <Component className={cn("ui-list", spacingClass, "text-sm text-slate-700", dense && "ui-list--dense list-dense", className)}>
      {children}
    </Component>
  );
}

export function ListItem({ className, children }: { className?: string; children: ReactNode }): JSX.Element {
  return (
    <li className={cn("ui-list-item rounded-lg border border-slate-200 bg-white p-3 transition", className)}>
      {children}
    </li>
  );
}
